<template>
    <div class="box-lr-wrapper">
        <div class="box-left rlms-flex rlms-flex-col rlms-gap-20">
            <div class="rlms-flex rlms-items-center rlms-justify-between rlms-flex-wrap rlms-gap-10">
                <RouterLink :to="`/admin/organizations/${organizationId}/learners`"
                    class="rlms-flex rlms-items-center rlms-gap-10 rlms-w-mc">
                    <img :src="mobileSidebarIcon" width="24" height="24" alt="">
                    <img :src="profileIcon">
                    <p class="rlms-fw-500" id="name-text">{{ learner?.firstname }} {{ learner?.lastname }}</p>
                </RouterLink>
            </div>
            <div class="detail-box rlms-border rlms-br-16">
                <div
                    class="detail-box-head rlms-flex rlms-justify-between rlms-items-center rlms-border-bottom rlms-flex-wrap rlms-gap-5">
                    <span class="rlms-fw-500 rlms-sm-sm">General information</span>
                    <div class="rlms-flex rlms-items-center rlms-gap-5 rlms-cursor-pointer rlms-popup-btn"
                        @click="showEditLearnerModal = true">
                        <img :src="editIcon">
                        <p class="rlms-text-primary-600">Edit</p>
                    </div>
                </div>
                <div class="detail-box-body" id="general-info-content">
                    <ul class="db-ul-style-2">
                        <li>
                            <span class="rlms-text-extra-3 rlms-fw-500">Code</span>
                            <p>{{ learner?.information_code }}</p>
                        </li>
                        <li>
                            <span class="rlms-text-extra-3 rlms-fw-500">Date Of Birth</span>
                            <p>{{ formatDate(learner?.dob) }}</p>
                        </li>
                        <li>
                            <span class="rlms-text-extra-3 rlms-fw-500">Gender</span>
                            <p v-if="learner?.gender == 1">Male</p>
                            <p v-if="learner?.gender == 2">Female</p>
                            <p v-if="learner?.gender == 3">Other</p>
                        </li>
                        <li>
                            <span class="rlms-text-extra-3 rlms-fw-500">Language</span>
                            <p>{{ capitalize(learner?.language?.name ?? "") }}</p>
                        </li>
                        <li>
                            <span class="rlms-text-extra-3 rlms-fw-500">Parents</span>
                            <p>{{ learner?.parents }}</p>
                        </li>
                        <li>
                            <span class="rlms-text-extra-3 rlms-fw-500">Status</span>
                            <div
                                :class="`rlms-bg-${learner?.setup ? 'success' : 'danger'}-100 rlms-text-${learner?.setup ? 'success' : 'danger'}-600 rlms-py-1 rlms-px-4 rlms-w-fc rlms-br-16 rlms-fw-500`">
                                {{ learner?.setup ? 'Active' : 'Inactive' }}
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="box-right rlms-flex rlms-flex-col rlms-gap-20">
            <div class="detail-box rlms-border rlms-br-16">
                <template v-if="learner?.subscriptions_details">
                    <div class="detail-box rlms-rounded subscription-detail-box rlms-br-16" style="background: #F9F6F1">
                        <div
                            class="detail-box-head rlms-flex rlms-justify-between rlms-items-center rlms-border-bottom rlms-flex-wrap rlms-gap-5">
                            <span class="rlms-fw-500 rlms-font-sm">Subscription</span>
                            <div class="rlms-flex rlms-items-center rlms-gap-5 rlms-cursor-pointer"
                                v-if="organization?.has_subscription && learner?.subscriptions_details?.is_expired"
                                @click="assignSubModal = true">
                                <svg id="fi_2921088" fill="#3E20FF" enable-background="new 0 0 24 24" height="20"
                                    viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="m12.25 2h-1.1c-.33-1.15-1.39-2-2.65-2s-2.32.85-2.65 2h-1.1c-.41 0-.75.34-.75.75v1.5c0 .96.79 1.75 1.75 1.75h5.5c.96 0 1.75-.79 1.75-1.75v-1.5c0-.41-.34-.75-.75-.75z">
                                    </path>
                                    <path
                                        d="m14.25 3h-.25v1.25c0 1.52-1.23 2.75-2.75 2.75h-5.5c-1.52 0-2.75-1.23-2.75-2.75v-1.25h-.25c-1.52 0-2.75 1.23-2.75 2.75v12.5c0 1.52 1.23 2.75 2.75 2.75h6.59c-.5-1.07-.8-2.25-.83-3.5h-4.76c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4.84c.09-.61.24-1.19.44-1.75h-5.28c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6c.39-.64.85-1.23 1.39-1.75h-7.39c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h9.44c1.15-.6 2.44-.96 3.81-.99v-2.76c0-1.52-1.23-2.75-2.75-2.75z">
                                    </path>
                                    <path
                                        d="m17.25 10.5c-3.722 0-6.75 3.028-6.75 6.75s3.028 6.75 6.75 6.75 6.75-3.028 6.75-6.75-3.028-6.75-6.75-6.75zm2.75 7.75h-1.75v1.75c0 .552-.448 1-1 1s-1-.448-1-1v-1.75h-1.75c-.552 0-1-.448-1-1s.448-1 1-1h1.75v-1.75c0-.552.448-1 1-1s1 .448 1 1v1.75h1.75c.552 0 1 .448 1 1s-.448 1-1 1z">
                                    </path>
                                </svg>
                                <p class="rlms-text-primary-600">Assign</p>
                            </div>
                        </div>
                        <div class="detail-box-body sd-box-body">

                            <p class="rlms-text-center rlms-text-danger-500"
                                v-if="learner?.subscriptions_details?.is_expired">
                                Learner subscription have been expired.
                                {{ organization?.has_subscription ? `Please assign the subscription.` : `Please first
                                purchase subscription
                                for assigning.` }}
                            </p>
                            <h4>{{ learner?.subscriptions_details?.product?.name }}</h4>
                            <ul>
                                <li>
                                    <span>Language</span>
                                    <p class="rlms-fw-600">{{ capitalize(learner?.language?.name) }}</p>
                                </li>
                                <li>
                                    <span>Beginning</span>
                                    <p class="rlms-fw-600">{{ learner?.subscriptions_details?.start_date }}</p>
                                </li>
                                <li>
                                    <span>Expiring</span>
                                    <p class="rlms-text-danger-500 rlms-fw-500">{{
                                        learner?.subscriptions_details?.end_date }}</p>
                                </li>
                                <li>
                                    <span>Status</span>
                                    <p class="rlms-text-danger-500 rlms-fw-500"
                                        v-if="learner?.subscriptions_details?.is_expired">Expired</p>
                                    <p class="rlms-text-success-600 rlms-fw-500" v-else>Active</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div
                        class="detail-box-head rlms-flex rlms-justify-between rlms-items-center rlms-border-bottom rlms-flex-wrap rlms-gap-5">
                        <span class="rlms-fw-500 rlms-font-sm">Subscriptions</span>
                        <div class="rlms-flex rlms-items-center rlms-gap-5 rlms-cursor-pointer"
                            v-if="organization?.has_subscription" @click="assignSubModal = true">
                            <svg id="fi_2921088" fill="#3E20FF" enable-background="new 0 0 24 24" height="20"
                                viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="m12.25 2h-1.1c-.33-1.15-1.39-2-2.65-2s-2.32.85-2.65 2h-1.1c-.41 0-.75.34-.75.75v1.5c0 .96.79 1.75 1.75 1.75h5.5c.96 0 1.75-.79 1.75-1.75v-1.5c0-.41-.34-.75-.75-.75z">
                                </path>
                                <path
                                    d="m14.25 3h-.25v1.25c0 1.52-1.23 2.75-2.75 2.75h-5.5c-1.52 0-2.75-1.23-2.75-2.75v-1.25h-.25c-1.52 0-2.75 1.23-2.75 2.75v12.5c0 1.52 1.23 2.75 2.75 2.75h6.59c-.5-1.07-.8-2.25-.83-3.5h-4.76c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4.84c.09-.61.24-1.19.44-1.75h-5.28c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6c.39-.64.85-1.23 1.39-1.75h-7.39c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h9.44c1.15-.6 2.44-.96 3.81-.99v-2.76c0-1.52-1.23-2.75-2.75-2.75z">
                                </path>
                                <path
                                    d="m17.25 10.5c-3.722 0-6.75 3.028-6.75 6.75s3.028 6.75 6.75 6.75 6.75-3.028 6.75-6.75-3.028-6.75-6.75-6.75zm2.75 7.75h-1.75v1.75c0 .552-.448 1-1 1s-1-.448-1-1v-1.75h-1.75c-.552 0-1-.448-1-1s.448-1 1-1h1.75v-1.75c0-.552.448-1 1-1s1 .448 1 1v1.75h1.75c.552 0 1 .448 1 1s-.448 1-1 1z">
                                </path>
                            </svg>
                            <p class="rlms-text-primary-600">Assign</p>
                        </div>
                    </div>
                    <div class="detail-box-body">
                        <div class="rlms-flex rlms-flex-col rlms-items-center rlms-text-center rlms-gap-10">
                            <svg xmlns="http://www.w3.org/2000/svg" width="58" height="59" viewBox="0 0 58 59"
                                fill="none">
                                <path
                                    d="M32.2461 23.584C31.2021 24.048 30.0421 24.396 28.8821 24.396C28.0701 24.396 27.2581 24.28 26.4461 24.048L29.1141 26.136L32.2461 23.584ZM41.2941 28.688C40.9461 28.456 37.9301 27.18 35.7261 26.252L35.6101 26.368L32.7101 31.356C32.3621 31.936 31.7821 32.168 31.2021 32.168C30.5061 32.168 29.9261 31.82 29.6941 31.24L29.1141 30.312L28.6501 31.24C28.3021 31.82 27.7221 32.168 27.1421 32.168C26.5621 32.168 25.9821 31.82 25.6341 31.24L22.6181 26.136C20.4141 27.064 17.3981 28.456 17.0501 28.572C16.4701 28.92 15.6581 29.268 15.0781 29.848L26.7941 32.98H31.4341L43.2661 29.964C42.6861 29.384 41.8741 28.92 41.2941 28.688Z"
                                    fill="#725CFF"></path>
                                <path
                                    d="M23.6659 25.7882L26.5659 30.7762C26.7979 31.1242 27.3779 31.1242 27.6099 30.7762L29.1179 27.9922L30.6259 30.7762C30.8579 31.1242 31.4379 31.2402 31.6699 30.7762L34.5699 25.7882L33.1779 24.3962L29.1179 27.5282L25.0579 24.3962L23.6659 25.7882ZM21.2299 16.2762C21.3459 16.2762 21.3459 16.2762 21.4619 16.1602C22.3899 20.2202 25.4059 23.2362 29.0019 23.2362C32.5979 23.2362 35.6139 20.2202 36.5419 16.1602C36.6579 16.1602 36.6579 16.2762 36.7739 16.2762C37.4699 16.3922 38.2819 15.3482 38.5139 13.9562C38.7459 12.5642 38.3979 11.2882 37.5859 11.1722H37.2379V10.8242C38.1659 5.60415 35.9619 3.63215 33.9899 3.40015H33.4099C33.2939 2.24015 32.9459 1.31215 31.5539 1.19615C29.1179 0.964152 21.1139 1.89215 20.5339 7.22815C20.5339 7.22815 20.1859 8.96815 20.3019 11.1722C19.7219 11.4042 19.3739 12.5642 19.6059 13.8402C19.7219 15.3482 20.4179 16.3922 21.2299 16.2762ZM26.7979 34.2562H31.4379V57.8042H26.7979V34.2562ZM46.1699 47.0162C44.8939 47.0162 43.8499 45.9722 43.8499 44.6962V39.5922C43.8499 38.4322 44.6619 37.5042 45.8219 37.3882L46.8659 37.2722V31.8202C46.8659 31.0082 46.1699 30.4282 45.3579 30.6602L32.4819 34.0242V57.3402L45.7059 52.9322C46.4019 52.7002 46.7499 52.1202 46.7499 51.4242V46.9002L46.2859 47.0162H46.1699ZM11.2539 31.8202V37.2722L12.0659 37.3882C13.2259 37.5042 14.0379 38.5482 14.0379 39.5922V44.6962C14.0379 45.9722 12.9939 47.0162 11.7179 47.0162H11.2539V51.5402C11.2539 52.2362 11.7179 52.8162 12.2979 53.0482L25.6379 57.3402V33.9082L12.7619 30.5442C12.0659 30.4282 11.2539 31.0082 11.2539 31.8202Z"
                                    fill="#725CFF"></path>
                                <path
                                    d="M47.4425 38.3161L46.1665 38.4321C45.5865 38.5481 45.2385 39.0121 45.2385 39.5921V44.6961C45.2385 45.3921 45.8185 45.8561 46.5145 45.8561L47.7905 45.7401C48.3705 45.6241 48.7185 45.1601 48.7185 44.5801V39.4761C48.6025 38.7801 48.0225 38.2001 47.4425 38.3161ZM12.8745 44.6961V39.5921C12.8745 39.0121 12.4105 38.5481 11.9465 38.4321L10.6705 38.3161C9.97453 38.2001 9.39453 38.7801 9.39453 39.4761V44.5801C9.39453 45.1601 9.85853 45.6241 10.3225 45.7401L11.5985 45.8561C12.2945 45.8561 12.8745 45.3921 12.8745 44.6961Z"
                                    fill="#725CFF"></path>
                            </svg>
                            <p>No subscriptions have been assigned to this learner. Please first purchase subscription
                                for assigning.</p>

                        </div>
                    </div>
                </template>
            </div>
            <div class="detail-box rlms-border rlms-br-16">
                <div class="detail-box-head rlms-border-bottom">
                    <span class="rlms-fw-500 rlms-sm-sm">Learners Groups</span>
                </div>
                <template v-if="learner?.groups?.length">
                    <div class="rlms-table">
                        <div class="rlms-table-inner">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Created</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="group in learner?.groups" :key="group.id">
                                        <td>
                                            <div class="rlms-flex rlms-items-center rlms-gap-10 rlms-w-mc">
                                                <div class="rlms-flex rlms-flex-col">
                                                    <div class="rlms-fw-500">{{ group.name }}</div>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            {{ formatDate(group.created_at) }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </template>
                <div class="detail-box-body rlms-flex rlms-flex-col rlms-gap-20 rlms-text-center" v-else>
                    <div class="rlms-avatar-group rlms-justify-center">
                        <div class="rlms-avatar">
                            <img :src="noImage">
                        </div>
                        <div class="rlms-avatar">
                            <img :src="noImage">
                        </div>
                        <div class="rlms-avatar">
                            <img :src="noImage">
                        </div>
                    </div>
                    <p>This learner is not part of any group</p>
                </div>
            </div>
        </div>
    </div>
    <AddEditLearnerModal v-if="showEditLearnerModal" @close="showEditLearnerModal = false;" @saved="init()"
        :organizationId="organizationId" :learner="learner" />

    <AssignSubscriptionModal v-if="assignSubModal" @close="assignSubModal = false;" @saved="init()"
        :organizationId="organizationId" :learnerId="learnerId" :subscription="organization?.has_subscription"
        :admin="true" />
</template>
<script setup>
import { useRoute } from 'vue-router'
import { onMounted, ref, capitalize } from 'vue'
import axios from "@/services/axios";
import { formatDate } from '@/utils/format-helpers';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useLoaderStore } from '@/stores/loader';
import mobileSidebarIcon from '@/assets/images/mobile_sidebar_blade_58652c7f.svg'
import profileIcon from '@/assets/images/profile.svg';
import noImage from '@/assets/images/no-image.png'
import { handleError } from '@/utils/handleError';
import AddEditLearnerModal from '@/components/AddEditLearnerModal.vue';
import AssignSubscriptionModal from '@/components/AssignSubscriptionModal.vue';
import editIcon from '@/assets/images/edit-icon.png'

const route = useRoute();
const loader = useLoaderStore()

const organizationId = Number(route.params.organization ?? 0);
const learnerId = Number(route.params.learner ?? 0);
const organization = ref(null);
const learner = ref(null);
const showEditLearnerModal = ref(false);
const assignSubModal = ref(false);
const binAssessmentModal = ref(false);


onMounted(async () => {
    init();
});

const init = async () => {
    showEditLearnerModal.value = false;
    assignSubModal.value = false;
    binAssessmentModal.value = false;
    await fetchLearner();
}

const fetchLearner = async () => {
    try {
        loader.show();
        const { data } = await axios.get(`/admin/organizations/${organizationId}/learners/${learnerId}`);
        organization.value = data.data;
        learner.value = organization.value.learner;
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
};
</script>
<style>
.features-coming-soon .swiper {
    width: 400px;
    height: 360px;
    border-radius: 20px;
    background: #E8F2FC;
}

.features-coming-soon .swiper-slide {
    padding: 20px;
    flex-direction: column !important;

    & img {
        width: 240px;
        margin: 0 auto;
    }

    & b {
        font-size: 20px;
        text-align: center;
        display: block;
        margin: 20px 0px;
    }

    & p {
        text-align: center;
    }
}

.swiper-slide {
    background: transparent;
}
</style>